import { createContext } from 'react';
export const LoadContext = createContext({
    loading: false,
    loadingRows: 0,
    loadingColumns: 0,
    initialLoading: false,
});
